import { createFileRoute } from "@tanstack/react-router";
import { SiteNav } from "@/components/site-nav";

const TITLE = "Lanzamiento V Radiografía de la Capacitación Online en Minería | Mine Class";
const DESC =
  "Inscríbete al lanzamiento de la V Radiografía de la Capacitación Online en Minería. Miércoles 25 de noviembre, 09:30 am, Fundación Chile, Vitacura.";
const URL = "https://mine-class.com/comunicaciones/eventos/v-radiografia";

export const Route = createFileRoute("/comunicaciones/eventos/v-radiografia")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: Page,
});

function Page() {
  return (
    <div className="flex h-screen flex-col">
      <SiteNav />
      <main className="flex-1">
        <h1 className="sr-only">Lanzamiento V Radiografía de la Capacitación Online en Minería</h1>
        <iframe
          src="/eventos/v-radiografia.html"
          title="Inscripción al lanzamiento de la V Radiografía"
          className="h-full w-full border-0"
        />
      </main>
    </div>
  );
}
